import { Currency } from "appworks/services/currency/currency";
import { gamevy } from "gamevy/gamevy";

export class GamevyCurrency extends Currency {

    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean): string {
        const options: any = {
            withoutCurrencySign: forceCreditMode,
            forceDecimals: trailingDecimals
        };
        return gamevy.commonUI.formatCurrency({ amount: value }, options);
    }
}
